<template>
  <router-view />
</template>

<script>
export default {};
</script>

<style>
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  background-color: #f9fafb;
}
</style>
